module.exports = __webpack_public_path__ + "img/1.205cc3b3.png";